import { Textarea } from '@dreryk/react-components';

import { translationKeys } from '../../translations';
import { PatientMedicalInformationRemoveFormController } from '../PatientMedicalInformationRemoveForm.types';

type PatientMedicalInformationRemoveDescriptionFieldProps = Pick<
   PatientMedicalInformationRemoveFormController,
   'register'
>;

export const PatientMedicalInformationRemoveDescriptionField = (
   props: PatientMedicalInformationRemoveDescriptionFieldProps
): JSX.Element => {
   return (
      <Textarea
         testId={'description'}
         controller={props.register('description', { required: true })}
         placeholder={translationKeys.specifyTheReasonForRemoval}
         rows={4}
         maxRows={4}
         maxLength={200}
      />
   );
};
